import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatBytes'
})
export class FormatBytesPipe implements PipeTransform {
  // tslint:disable-next-line:no-any
  transform(value: any, decimals: number): any {
    // Value is not a number return as is.
    if (isNaN(Number(value))) {
      return value;
    }
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const dm = decimals + 1;
    if (value === 0) {
      return 'n/a';
    }
    const i = Math.floor(Math.log(value) / Math.log(1024));
    if (i === 0) {
      return value + ' ' + sizes[i];
    }
    return (value / Math.pow(1024, i)).toFixed(dm) + ' ' + sizes[i];
  }
}
